import { booleanAttribute } from "#ce/utils/props";
// We had bugs in the past, where the props were mutatated. Apply Object.freeze() to prevent this.
export const props = Object.freeze({
  /**
   * Primary image source URL. Used as the fallback when none of the responsive sources match.
   *
   * @type {String}
   * @default undefined
   */
  src: {
    type: String,
    required: true,
  },

  /**
   * Image source for small screens (max-width: 768px).
   *
   * @type {String}
   * @default undefined
   */
  srcSmall: {
    type: String,
    default: undefined,
  },

  /**
   * Image source for medium screens (max-width: 1024px).
   *
   * @type {String}
   * @default undefined
   */
  srcMedium: {
    type: String,
    default: undefined,
  },

  /**
   * Image source for large screens (min-width: 1024px).
   *
   * @type {String}
   * @default undefined
   */
  srcLarge: {
    type: String,
    default: undefined,
  },

  /**
   * Alternative text for the image. Important for accessibility and SEO.
   *
   * @type {String}
   * @default undefined
   */
  alt: {
    type: String,
    default: undefined,
  },

  /**
   * Browser loading behaviour. "lazy" defers loading until the image is near the viewport; "eager" loads immediately.
   *
   * @type {String}
   * @default "lazy"
   * @values lazy, eager
   * @storybook-control radio
   */
  loading: {
    type: String,
    default: "lazy",
    validator: (value) => ["lazy", "eager"].includes(value),
  },

  /**
   * Fetch priority hint for the image.
   *
   * @type {String}
   * @default "auto"
   * @values auto, low, high
   * @storybook-control radio
   */
  fetchpriority: {
    type: String,
    default: "auto",
    validator: (value) => ["auto", "low", "high"].includes(value),
  },

  /**
   * Defer loading the image until `load()` is called on the host element.
   *
   * @type {Boolean|String}
   * @default false
   */
  defer: booleanAttribute(),
});
